import {
  Component,
  OnInit,
  ViewEncapsulation,
  Inject
} from "@angular/core";
import { Location } from '@angular/common';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "pdf-dialog",
  templateUrl: "./pdf-dialog.component.html",
  styleUrls: ["./pdf-dialog.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PDFDialogComponent implements OnInit {
  title: string;
  src: string;
  isBack: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string, filename: string, url: string, isBack: boolean, },
    private location: Location) {
    //   this.title = this.data.title;
    //   this.isBack = this.data.isBack;
    //  if (this.data.url) {
    //   this.src = this.data.url;  // Use external URL
    // } else if (this.data.filename) {
    //   // Construct local file URL if filename is provided
    //   this.src = window.location.origin + this.location.prepareExternalUrl(`assets/pdf/${this.data.filename}`);
    // } else {
    //   console.error("No URL or filename provided for PDF.");
    // }
    this.title = this.data.title;
    this.isBack = this.data.isBack;
    this.src = window.location.origin + this.location.prepareExternalUrl(`assets/pdf/${this.data.filename}`);
    }

  ngOnInit() { }
}
